<ng-template #customLoadingTemplate> </ng-template>
<ngx-loading
  [show]="loading"
  class="loader"
  [template]="customLoadingTemplate"
></ngx-loading>
<site-header></site-header>

<div class="content-wrapper">
  <!-- Content Header (Page header) -->
  <div class="content-header breadcrumb_area">
    <div class="container-fluid">
      <div class="row mb-2">
        <div class="col-sm-12">
          <ol class="breadcrumb cron_main">
            <li class="breadcrumb-item active">Student List 2.0</li>
          </ol>
        </div>
      </div>
      <!-- /.row -->
    </div>
    <!-- /.container-fluid -->
  </div>
  <!-- /.content-header -->
  <!-- Main content -->
  <section class="content">
    <div class="container-fluid page_section">
      <div class="serach_sec">
        <div class="row">
          <div class="col-sm-12">
            <div class="order-head">Search</div>
          </div>
        </div>
        <div class="search_cls">
          <div class="row">
            <div class="col-sm-2 search-by-col">
              <select
                id="filterField"
                class="normal_background form-control"
                (change)="onFilterFieldChange($event)"
              >
                <option
                  *ngFor="let f of filter_fields"
                  [value]="f.value"
                  [selected]="f.value == filter_field"
                >
                  {{ f.name }}
                </option>
              </select>
            </div>
            <div class="col-sm-3 search-value-col">
              <input
                type="Search"
                name="searchValue"
                id="searchValue"
                (keyup.enter)="search($event)"
                placeholder="Enter search value"
                autocomplete="off"
              />
            </div>
            <div class="col-sm-1">
              <div class="reset_btn">
                <button
                  (click)="resetFilter($event)"
                  class="btn btn-secondary btn-sm"
                >
                  Reset
                </button>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="flex flt" style="justify-content: flex-end;">
                <input
                  type="text"
                  id="fetchEnrollmentId"
                  name="fetchEnrollmentId"
                  placeholder="Enter Enrollment ID"
                  autocomplete="off"
                  [(ngModel)]="fetch_enrollment_id"
                  style="margin-right: 10px; max-width: 220px;"
                />
                <div class="reset_btn">
                  <button
                    (click)="fetchUser($event)"
                    [disabled]="fetching"
                    class="btn btn-secondary btn-sm"
                  >
                    Fetch User
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 10px;">
            <div class="col-sm-2">
              <label class="date_filter_label">From Date</label>
              <input
                type="date"
                id="fromDate"
                name="fromDate"
                [(ngModel)]="fromDate"
                (change)="onFromDateChange($event)"
              />
            </div>
            <div class="col-sm-2">
              <label class="date_filter_label">To Date</label>
              <input
                type="date"
                id="toDate"
                name="toDate"
                [min]="fromDate"
                [disabled]="!fromDate"
                [(ngModel)]="toDate"
                (change)="onToDateChange($event)"
              />
            </div>
          </div>
        </div>
      </div>

      <div class="order_tabs">
        <div class="row">
          <div class="col-sm-12">
            <div class="order_tabs">
              <div class="tab-content">
                <div class="tab-pane active" id="menu1">
                  <div class="order_list">
                    <span class="total_count"
                      >Total Count :
                      {{
                        totalcount ? (totalcount | number : "1.0" : "en-US") : 0
                      }}</span
                    >
                    <div class="table-responsive">
                      <table
                        class="table table-hover dataTable admin_table"
                        style="width: 3000px"
                      >
                        <thead>
                          <tr>
                            <th width="140px">Enrollment No.</th>
                            <th width="250px">Name</th>
                            <th width="250px">Certificate Name</th>
                            <th width="150px">Student Status</th>
                            <th width="150px">Sub Status</th>
                            <th width="180px">Course Completion Date</th>
                            <th width="60px">Gender</th>
                            <th width="100px">DOB</th>
                            <th width="260px">Email</th>
                            <th width="260px">Learner ID</th>
                            <th width="120px">Mobile No.</th>
                            <th width="130px">Aadhaar No.</th>
                            <th width="300px">Branch</th>
                            <th width="300px">Course</th>
                            <th width="150px">Degree</th>
                            <th width="300px">Institution</th>
                            <th width="140px">Vertical</th>
                            <th width="90px">Semester</th>
                            <th width="70px">Year</th>
                            <th width="130px">Gold Medallist</th>
                            <th width="130px">Honour Student</th>
                            <th width="80px">Action</th>
                          </tr>
                        </thead>

                        <tbody>
                          <ng-container
                            *ngFor="
                              let list of student_list
                                | paginate
                                  : {
                                      itemsPerPage: pageSize,
                                      currentPage: cur_page,
                                      totalItems: totalcount
                                    };
                              let x = index
                            "
                          >
                            <tr>
                              <td>
                                {{
                                  list && list.enrollment_Number
                                    ? list.enrollment_Number
                                    : "-"
                                }}
                              </td>
                              <td class="name_cls">
                                {{ list && list.name ? list.name : "-" }}
                              </td>
                              <td class="name_cls">
                                {{ list && list.certificate_name ? list.certificate_name : "-" }}
                              </td>
                              <td>
                                {{ list && list.student_status ? list.student_status : "-" }}
                              </td>
                              <td>
                                {{ list && list.sub_status ? list.sub_status : "-" }}
                              </td>
                              <td>
                                {{ list && list.course_completion_date ? (list.course_completion_date|date:'dd-MM-yyyy') : "-" }}
                              </td>
                              <td>
                                {{ list && list.gender ? list.gender : "-" }}
                              </td>
                              <td>{{ list && list.dob ? list.dob : "-" }}</td>
                              <td>
                                {{ list && list.email ? list.email : "-" }}
                              </td>
                              <td>
                                {{ list && list.learner_id ? list.learner_id : "-" }}
                              </td>
                              <td>
                                {{
                                  list && list.phone_no ? list.phone_no : "-"
                                }}
                              </td>
                              <td>
                                {{
                                  list && list.adhaar_number
                                    ? list.adhaar_number
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{ list && list.branch ? list.branch : "-" }}
                              </td>
                              <td>
                                {{ list && list.course ? list.course : "-" }}
                              </td>
                              <td>
                                {{ list && list.degree ? list.degree : "-" }}
                              </td>
                              <td>
                                {{
                                  list && list.institution
                                    ? list.institution
                                    : "-"
                                }}
                              </td>
                              <td>
                                {{ list && list.vertical ? list.vertical : "-" }}
                              </td>
                              <td>
                                {{ list && list.semester ? list.semester : "-" }}
                              </td>
                              <td>
                                {{ list && list.year ? list.year : "-" }}
                              </td>
                              <td>
                                {{ list && list.is_gold_medallist ? list.is_gold_medallist : "-" }}
                              </td>
                              <td>
                                {{ list && list.is_honour_student ? list.is_honour_student : "-" }}
                              </td>
                              <td>
                                <a href="javascript:void(0)" (click)="openEdit($event, list)">
                                  <i class="fa fa-pencil-alt"></i>
                                </a>
                              </td>
                            </tr>
                          </ng-container>
                          <tr *ngIf="!student_list.length">
                            <td colspan="22" class="text-center">
                              No Results Found
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <br />
                  <div class="paginate">
                    <p>
                      Showing {{ from }} to {{ cur_page * 10 }} of
                      {{ totalcount }} entries
                    </p>
                    <pagination-controls
                      previousLabel="Prev"
                      nextLabel="Next"
                      responsive="true"
                      (pageChange)="changePage($event)"
                    ></pagination-controls>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- /.col -->
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->
  </section>
</div>

<div
  class="modal fade"
  id="editUserModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="editUserModalLabel"
>
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="editUserModalLabel">
          Edit Student{{ edit_name ? " - " + edit_name : "" }}
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
          (click)="closeEdit($event)"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label>Enrollment No.</label>
          <input
            type="text"
            class="form-control"
            [value]="edit_enrollment_Number"
            readonly
          />
        </div>
        <div class="form-group">
          <label>Semester</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="edit_semester"
            name="edit_semester"
            autocomplete="off"
          />
        </div>
        <div class="form-group">
          <label>Year</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="edit_year"
            name="edit_year"
            autocomplete="off"
          />
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary btn-sm"
          (click)="closeEdit($event)"
        >
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-primary btn-sm"
          [disabled]="saving"
          (click)="saveEdit($event)"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</div>
